import { lazy } from 'react';
import PATH from 'routes/paths';

const DirectMessagesTab = lazy(() =>
  import('containers/generalChat/directMessages/DirectMessagesTab')
);

const ProjectsMessagesTab = lazy(() =>
  import('containers/generalChat/projects/ProjectsMessagesTab')
);

/** Chat pm & apm paths */

const PROJECT_BASED_CHAT_CONVERSATION_LIST = {
  component: DirectMessagesTab,
  path: PATH.PROJECT.CHAT.CONVERSATION.LIST,
  exact: true,
  isProtected: true,
};

const PROJECT_BASED_CHAT_CONVERSATION_ONE = {
  component: DirectMessagesTab,
  path: PATH.PROJECT.CHAT.CONVERSATION.ONE,
  exact: true,
  isProtected: true,
};

const PROJECT_BASED_CHAT_CHANNELS_LIST = {
  component: ProjectsMessagesTab,
  path: PATH.PROJECT.CHAT.CHANNEL.LIST,
  exact: true,
  isProtected: true,
};

const PROJECT_BASED_CHAT_CHANNELS_ONE = {
  component: ProjectsMessagesTab,
  path: PATH.PROJECT.CHAT.CHANNEL.ONE,
  exact: true,
  isProtected: true,
};

export default [
  /** Chat pm & apm paths */
  PROJECT_BASED_CHAT_CONVERSATION_LIST,
  PROJECT_BASED_CHAT_CONVERSATION_ONE,

  PROJECT_BASED_CHAT_CHANNELS_LIST,
  PROJECT_BASED_CHAT_CHANNELS_ONE,
];
